import React from "react";

import { RegisterPhonePage } from "../register-phone-page/register-phone-page";

import { DocTooManyAttempts } from "./doc-too-many-attempts";
import { IncorrectCodeConfirm } from "./incorrect-code-confirm";
import { TimeExpired } from "./time-expired";

export const ErrorPage = () => {
  const error = window.errorOnErrorPage;

  switch (error) {
    /** Достигнуто максимальное количество попыток ввода кода из смс */
    case "userNotFound":
      return <IncorrectCodeConfirm />;
    case "docAuthTooManyAttempts": // Достигнуто максимальное количество попыток ввода паспорта
    case "updatePasswordTooOften": // Вы не можете менять пароль слишком часто
      return <DocTooManyAttempts />;
    /** Время ожидания истекло при вводе пароля */
    case "notAuthorized":
      return <TimeExpired title={"Время ожидания истекло"} />;
    /** Некорректный номер телефона */
    case "smsAuthSmsNotSent":
      return <RegisterPhonePage />;
    default:
      return <div>неизвестная ошибка</div>;
  }
};
